import { render } from "./organization-merge.vue?vue&type=template&id=c89a4c04&scoped=true"
import script from "./organization-merge.vue?vue&type=script&lang=js"
export * from "./organization-merge.vue?vue&type=script&lang=js"

import "./organization-merge.vue?vue&type=style&index=0&id=c89a4c04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c89a4c04"]])

export default __exports__